module.exports = __webpack_public_path__ + "static/img/photo_2020-11-13_18-19-13.ac5c173.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup/photo_2020-11-13_18-19-13.jpg
// module id = s8PD
// module chunks = 25